import { Pipe, PipeTransform } from '@angular/core';
import { LocaleString } from '../translate/localeString.model';
import { LocalizeService } from './localize.service';

@Pipe({
    name: 'localize',
    pure: false,
    standalone: false
})
export class LocalizePipe implements PipeTransform {

    constructor(private localize: LocalizeService) { }

    transform(value: LocaleString | string): string {
        return this.localize.transform(value);
    }

}
